import * as React from 'react';
import { BestDeterminer } from '../../lib/determiner';
import { BaseRow, BaseRowFactory } from '../BaseRow';

export class PatternRow extends BaseRow<PatternRowFactory> {
  renderData() {
    return <span>{this.props.data.value}</span>
  }
}

export class PatternRowFactory extends BaseRowFactory<typeof PatternRow, { value: string }, {
  length: number,
  pattern: string | string[],
  chunk?: number
}> {
  generate(input: this['TInput']) {
    const chunk = input.chunk || 10;
    let result = "";
    while (result.length < input.length) {
      result += BestDeterminer.pattern(chunk, input.pattern);
    }
    return { value: result.slice(0, input.length) }
  }

  component = PatternRow
}
